const stages = [
  { name: "New Inquiry", count: 847, color: "bg-gray-400" },
  { name: "Site Visit Sch", count: 634, color: "bg-blue-400" },
  { name: "Site Visit Done", count: 423, color: "bg-indigo-500" },
  { name: "Proposal Sent", count: 267, color: "bg-amber-500" },
  { name: "Negotiation", count: 134, color: "bg-orange-500" },
  { name: "Booking Done", count: 89, color: "bg-green-500" },
  { name: "Lost", count: 45, color: "bg-red-400" },
];

const maxCount = stages[0].count;

export default function PipelineHealthFunnel() {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-gray-900">Pipeline Health</h3>
        <p className="text-xs text-gray-500 mt-0.5">Today&apos;s snapshot</p>
      </div>

      <div className="space-y-2.5">
        {stages.map((stage) => {
          const pct = (stage.count / maxCount) * 100;
          return (
            <div key={stage.name} className="flex items-center gap-3">
              <span className="text-xs text-gray-600 w-28 flex-shrink-0 whitespace-nowrap">{stage.name}</span>
              <div className="flex-1 min-w-0 mx-1">
                <div className="h-3 bg-gray-100 rounded-full overflow-hidden">
                  <div
                    className={`h-full ${stage.color} rounded-full transition-all duration-500`}
                    style={{ width: `${Math.max(pct, 2)}%` }}
                  />
                </div>
              </div>
              <span className="text-xs font-medium text-gray-900 w-10 text-right flex-shrink-0">
                {stage.count}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}